import { stripHTML } from "@/utils/utils";
import clsx from "clsx";
import type { ProductAttribute } from "@/types/products";
import type { AvailableTermsSetMap, SelectedTerms } from "@/features/productVariations";

interface ProductAttributesProps {
  attributes: ProductAttribute[];
  selectedTerms: SelectedTerms;
  availableTermsSetMap: AvailableTermsSetMap;
  isLoading: boolean;
  handleAttributeSelect: (attributeName: string, termName: string) => void;
}

const ProductAttributes = ({
  attributes,
  selectedTerms,
  availableTermsSetMap,
  isLoading,
  handleAttributeSelect,
}: ProductAttributesProps) => {
  return (
    <div className="flex flex-col gap-4">
      {attributes.map((attr) => (
        <div key={attr.name}>
          <div className="brand-text-sm font-bold text-base-content">{attr.name}</div>
          <div className="gap-x4 mt-2 flex flex-wrap gap-2">
            {attr.terms.map((term) => {
              const isSelected = selectedTerms?.[attr.name] === term.name;
              const isAvailable = availableTermsSetMap?.[attr.name]?.has(term.name);

              return (
                <button
                  key={term.name}
                  disabled={!isAvailable}
                  onClick={() => handleAttributeSelect(attr.name, term.name)}
                  className={clsx("brand-btn-accent-light", {
                    "is-active": isSelected,
                    "brand-animate-shimmer-wave brand-animate-shimmer-pulse": isLoading,
                  })}
                >
                  {stripHTML(term.name)}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductAttributes;
